class QuantityStepper extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.hdt-qty-stepper__input');
    this.minusBtn = this.querySelector('.hdt-qty-stepper__btn--minus');
    this.plusBtn = this.querySelector('.hdt-qty-stepper__btn--plus');

    if (!this.input || !this.minusBtn || !this.plusBtn) return;

    this.min = parseInt(this.dataset.min, 10) || 1;
    this.max = this.dataset.max ? parseInt(this.dataset.max, 10) : null;
    this.step = parseInt(this.dataset.step, 10) || 1;

    this.minusBtn.addEventListener('click', this.decrease.bind(this));
    this.plusBtn.addEventListener('click', this.increase.bind(this));
    this.input.addEventListener('change', this.onInputChange.bind(this));

    this.updateButtonStates();
  }

  getValue() {
    return parseInt(this.input.value, 10) || this.min;
  }

  setValue(value) {
    let next = value;

    if (this.max !== null) next = Math.min(next, this.max);
    next = Math.max(next, this.min);

    this.input.value = next;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    this.updateButtonStates();
  }

  decrease() {
    if (this.minusBtn.disabled) return;
    this.setValue(this.getValue() - this.step);
  }

  increase() {
    if (this.plusBtn.disabled) return;
    this.setValue(this.getValue() + this.step);
  }

  onInputChange() {
    this.setValue(this.getValue());
  }

  updateButtonStates() {
    const value = this.getValue();
    this.minusBtn.disabled = value <= this.min;
    this.plusBtn.disabled = this.max !== null && value >= this.max;
  }
}

customElements.define('quantity-stepper', QuantityStepper);